export interface DictRef {
    id: string;
    name: string;
}

export interface RefOption {
    id: string;
    code: string;
    nameRu: string;
}

export interface FootballRefOptions {
    kitTypes: RefOption[];
    kitVersions: RefOption[];
    sleevesTypes: RefOption[];
    sizes: RefOption[];
}

/** The jersey half of a kit (always present); version/size are independent of the shorts. */
export interface JerseyPart {
    version: RefOption | null;
    size: RefOption | null;
    number: number | null;
    playerName: string | null;
    sleevesType: RefOption | null;
    patch: DictRef | null;
    photoUrls: string[] | null;
}

/** The optional shorts half of a kit; can be a different version than the jersey. */
export interface ShortsPart {
    version: RefOption | null;
    size: RefOption | null;
    number: number | null;
    photoUrls: string[] | null;
}

/**
 * A football kit (комплект): a jersey + optional shorts, classified by club / season / type.
 */
export interface FootballKit {
    id: string;
    club: DictRef | null;
    season: DictRef | null;
    kitType: RefOption | null;
    brand: DictRef | null;
    notes: string | null;
    jersey: JerseyPart;
    shorts: ShortsPart | null;
    createdAt: string | null;
    updatedAt: string | null;
}

export const FOOTBALL_IMAGE_BASE = '/football/images/';
